import type { AddressProps } from '../../shared/Module'
import React from 'react'

interface AddressLinesProps extends AddressProps {
  separator?: React.ReactNode | string
}

const AddressLines = ({
  address,
  city,
  civility,
  company,
  complement,
  country,
  firstName,
  lastName,
  mobilePhone,
  zipCode,
  separator = ' - ',
}: AddressLinesProps) => {
  return (
    <>
      <strong className='c-address__label'>
        {civility === 'mrs' ? 'Mme' : 'M.'} {firstName} {lastName}
      </strong>
      {mobilePhone}
      <br />
      {company && (
        <>
          {company}
          <br />
        </>
      )}
      {address}
      {separator}
      {zipCode} {city}
      <br />
      {complement && (
        <>
          {complement}
          <br />
        </>
      )}
      {country}
    </>
  )
}

export default AddressLines
